<template>
  <div id="header-home-image">

    <div id="header-top">
      <div id="home-localise-cta"
           class="home-localise-cta xs-flex xs-justify-start xs-items-center xs-flex-column home-localise-cta--c5 xs-mnb-30 md-mb-0">
        <!--        <h1 class="logo-home xs-shrink-0 screenreader-only xs-my-5" style="z-index: 1000;">Pizza Hut</h1>-->
      </div>
    </div>
    <div v-if="showLocation" data-module-name="localisation-tool" data-module-placement="hero"
         class="home-localise-content xs-z-200 new-disposition ">
      <div v-if="isVarriant1" class="logo-variant-1"></div>
      <div class="localisation-form xs-relative xs-mx-auto xs-z-400">
        <div v-if="isVarriant1 && !hasDisposition" class="message_home_variant_1 flex">
          <div class="pr-10"><i class="fa fa-exclamation-circle fa-lg"></i></div>
          <div class="flex1">{{$t('message_home_variant_1')}}</div>
        </div>
        <BannerRibbon />
        <home-localization-map-asia
          v-if="$const.LOCALIZATION_TYPE == $const.LOCALIZATION_TYPES.MAP_ASIA"></home-localization-map-asia>
        <!--phi,sin,malay-->
        <home-localization-map
          v-else-if="$const.LOCALIZATION_TYPE == $const.LOCALIZATION_TYPES.MAP"></home-localization-map><!--japan-->
        <home-localization-map-google-api v-else></home-localization-map-google-api><!--new zealand-->
      </div>
    </div>
  </div>


</template>
<script>
  import HomeLogin from '@/components/home/HomeLogin.vue'
  import HomeLocalizationMapAsia from './HomeLocalizationMapAsia.vue'
  import HomeLocalizationMap from './HomeLocalizationMap.vue'
  import HomeLocalizationMapGoogleApi from './HomeLocalizationMapGoogleApiNewDesign.vue'
  import UserTopMobile from '../partials/UserTopMobile'
  import {getExperiment} from '@pizza-hut/lib-experiments/lib'
  import HomeReOrder from './HomeReOrder.vue'
  import BannerRibbon from '@/components/popup/BannerRibbon'

  export default {
    components: {
      HomeLocalizationMap,
      HomeLocalizationMapAsia,
      HomeLocalizationMapGoogleApi,
      UserTopMobile,
      HomeReOrder,
      BannerRibbon
    },
    props: {
      isVarriant1: {
        type: Boolean,
        default: false
      },
      showLocation: {
        type: Boolean,
        default: true,
      },
      isLanding: false,
      routeLanding: false,
      isShowRibbon: {
        type: Boolean,
        default: true
      }
    },
    created() {
      // ROLO
      // const checkLayout = getExperiment('CVR', 'lastOrder')
      // if (checkLayout === this.getValueExperiment('lastOrder', 'show')) {
      //   this.ABtesttingLastOrder = true
      //   this.getConfigTenant()
      // }
      // if (checkLayout === null) {
      //   this.sendEventGA(this, 'CVR', 'lastOrder', 'notShow', null, false)
      // }
    },
    mounted() {
      this.$root.$on('updateHasDisposition', (data) => {
        this.hasDisposition = data
      })
    },
    data() {
      return {
        lang: this.$session.get('lang'),
        flag: false,
        client: 1,
        hasDisposition: this.checkPosition(this),
        ABtesttingLastOrder: false,
        reorderLastOrder: 0
      }
    },
    methods: {
      toggleLogin() {
        this.flag = !this.flag
      },
      changeLang(la) {
        this.lang = la
        this.$store.dispatch('setLang', la)
        this.$session.set('lang', la)
        this.$router.go(this.$router.currentRoute)
      },

      getConfigTenant () {
        let vm = this
        let params = {
            manual: 1
        }
        vm.axios.apiTenant.getConfigByClient(params, function (response) {
            vm.reorderLastOrder = response.data.data.item && response.data.data.item.reorder_last_order ? response.data.data.item.reorder_last_order : 0
        })
      }
    }
  }
</script>
<style scoped>
  .logo-variant-1 {
    background-image: url("https://static.phdvasia.com/my/icons/Hat_full.svg");
    background-repeat: no-repeat;
    background-position: center;
    height: 120px;
    width: 120px;
    margin: 0 auto;
    margin-bottom: 60px;
    display: none;
  }

  .dropdown-lang button {
    border: none;
  }

  .dropdown-lang .dropdown-menu > li > a {
    padding: 3px 12px;
  }

  .ribbon-home-banner {
    display: flex;
    margin: auto;
    margin-bottom: 10px;
    transform: translateY(30px) scale(1.21);
    width: 100%;
  }

  .message_home_variant_1 {
    background: rgba(255, 255, 255, 0.9);
    padding: 10px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/HomeTop.vue